import { render } from "./TcpaDisclaimer.vue?vue&type=template&id=e278d466"
import script from "./TcpaDisclaimer.vue?vue&type=script&lang=js"
export * from "./TcpaDisclaimer.vue?vue&type=script&lang=js"

import "./TcpaDisclaimer.vue?vue&type=style&index=0&id=e278d466&lang=css"

import exportComponent from "../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__